import { gsap } from 'gsap'
import { on } from 'delegated-events'
import fullpage from 'fullpage.js'

const panels = Array.from(document.querySelectorAll('.product-panel'))
const panelIndicator = document.querySelector('.products-indicator')
let enterAnimations = []
let exitAnimations = []

const fn = {
  init: () => {
    fn.setupAnimations()

    const fp = new fullpage('#main-content', {
      licenseKey: '9BA5764A-0CF54B26-8FC63470-8461F116',
      keyboardScrolling: false,
      lockAnchors: true,
      recordHistory: false,
      onLeave: (origin, destination) => {
        fn.handlePanelExit(origin.item)
        fn.handlePanelEnter(destination.item)
      },
    })

    fn.handlePanelEnter(panels[0])

    on('click', 'button[data-anchor]', (e) => {
      const button = e.target.closest('button')

      if (button) {
        fp.moveTo(button.dataset.anchor)
      }
    })
  },

  handlePanelExit: (panel) => {
    if (!panel.classList.contains('product-panel')) {
      return
    }

    const index = panels.indexOf(panel)

    exitAnimations[index].restart()
  },

  handlePanelEnter: (panel) => {
    if (!panel.classList.contains('product-panel')) {
      return
    }

    const panelColor = panel.dataset.color
    document.documentElement.style.setProperty('--active-product-color', panelColor)

    const index = panels.indexOf(panel)

    enterAnimations[index].restart()

    const indicator = panelIndicator.querySelector(`[data-indicator="${index + 1}"]`)

    if (indicator) {
      panelIndicator.querySelectorAll('button').forEach((x) => x.classList.remove('is-active'))
      indicator.classList.add('is-active')
    }
  },

  setupAnimations: () => {
    const isMobile = window.matchMedia('(max-width: 767px)').matches
    const isDesktop = !isMobile

    panels.forEach((el) => {
      const enter = gsap.timeline({
        paused: true,
        delay: 0.5,
      })

      const details = el.querySelector('.product-details')
      const topImage = el.querySelector('.product-image-top')
      const leftImage = el.querySelector('.product-image-left')
      const centerImage = el.querySelector('.product-image-center')
      const bottomImage = el.querySelector('.product-image-bottom')
      const rightImage = el.querySelector('.product-image-right')

      enter.add('start')
      enter.fromTo(centerImage, { translateY: '20%' }, { translateY: 0, duration: 1.5, ease: 'back' })

      enter.fromTo(
        details,
        { translateY: '20%', opacity: 0 },
        { translateY: 0, opacity: 1, duration: 1, delay: 1.25, ease: 'back' },
        'start'
      )

      if (topImage && isMobile) {
        enter.fromTo(
          topImage,
          { opacity: 0, translateX: '10%', translateY: '-15%' },
          { opacity: 1, translateX: 0, translateY: 0, duration: 2, ease: 'back', delay: 0.5 },
          'start'
        )
      }

      if (leftImage && isDesktop) {
        enter.fromTo(
          leftImage,
          { opacity: 0, translateY: '10%' },
          { opacity: 1, translateY: 0, duration: 2, ease: 'back', delay: 0.5 },
          'start'
        )
      }

      if (bottomImage && isMobile) {
        enter.fromTo(
          bottomImage,
          { opacity: 0, translateX: '-10%', translateY: '15%' },
          { opacity: 1, translateX: 0, translateY: 0, duration: 2, ease: 'back', delay: 0.5 },
          'start'
        )
      }

      if (rightImage && isDesktop) {
        enter.fromTo(
          rightImage,
          { opacity: 0, translateY: '10%' },
          { opacity: 1, translateY: 0, duration: 2, ease: 'back', delay: 1 },
          'start'
        )
      }

      enterAnimations.push(enter)

      const exit = gsap.timeline({
        paused: true,
      })

      exit.to(details, { opacity: 0, ease: 'back' })

      exitAnimations.push(exit)
    })
  },
}

export default {
  can: () => document.body.classList.contains('products-landing-page'),
  run: fn.init,
}
